type ContactNameFields = {
   firstName?: unknown;
   lastName?: unknown;
   businessName?: unknown;
   emails?: unknown;
   phoneNumbers?: unknown;
};

const text = (value: unknown) => typeof value === "string" && value.trim() ? value.trim() : undefined;

/** Prefer a person's name, then business, email, or phone; callers choose the unresolved fallback. */
export function contactDisplayName(contact: ContactNameFields): string | undefined {
   const name = [text(contact.firstName), text(contact.lastName)].filter(Boolean).join(" ");
   if (name) return name;
   const business = text(contact.businessName);
   if (business) return business;
   const email = Array.isArray(contact.emails) ? contact.emails.map(text).find(Boolean) : undefined;
   if (email) return email;
   return Array.isArray(contact.phoneNumbers) ? contact.phoneNumbers.map(phone =>
      phone && typeof phone === "object" ? text(phone.number) : undefined).find(Boolean) : undefined;
}
